import { chain } from 'icepick';
import queryString from 'query-string';
import type { Location } from '@atlassian/jira-router';
import {
	ASSIGNEE,
	LABEL,
	TEXT,
	ISSUE_PARENT,
	ISSUE_TYPE,
	VERSION,
	CUSTOM_FILTER,
} from '../../model/filters/constants';
import type { Filters } from '../../model/filters/types';
import {
	QUERY_PARAM_ASSIGNEE,
	QUERY_PARAM_LABEL,
	QUERY_PARAM_TEXT,
	QUERY_PARAM_ISSUE_PARENT,
	QUERY_PARAM_ISSUE_TYPE,
	QUERY_PARAM_VERSION,
	QUERY_PARAM_CUSTOM_FILTER,
} from '../../model/routing/constants';

export const getPushPayload = (
	filters: Filters,
	location: Location,
	isCompanyManaged?: boolean,
) => {
	const search = chain({
		...queryString.parse(location.search),
	});

	filters[TEXT] ? search.set(QUERY_PARAM_TEXT, filters[TEXT]) : search.unset(QUERY_PARAM_TEXT);
	filters[ASSIGNEE]
		? search.set(QUERY_PARAM_ASSIGNEE, filters[ASSIGNEE].join(','))
		: search.unset(QUERY_PARAM_ASSIGNEE);
	filters[LABEL]
		? search.set(QUERY_PARAM_LABEL, filters[LABEL].join(','))
		: search.unset(QUERY_PARAM_LABEL);
	filters[ISSUE_PARENT]
		? search.set(QUERY_PARAM_ISSUE_PARENT, filters[ISSUE_PARENT].join(','))
		: search.unset(QUERY_PARAM_ISSUE_PARENT);
	filters[ISSUE_TYPE]
		? search.set(QUERY_PARAM_ISSUE_TYPE, filters[ISSUE_TYPE].join(','))
		: search.unset(QUERY_PARAM_ISSUE_TYPE);
	filters[VERSION]
		? search.set(QUERY_PARAM_VERSION, filters[VERSION].join(','))
		: search.unset(QUERY_PARAM_VERSION);
	if (isCompanyManaged) {
		filters[CUSTOM_FILTER]
			? search.set(QUERY_PARAM_CUSTOM_FILTER, filters[CUSTOM_FILTER].join(','))
			: search.unset(QUERY_PARAM_CUSTOM_FILTER);
	}
	return {
		...location,
		search: queryString.stringify(search.value()),
	};
};
